// import OS from './os'
import { fetch } from '@/api/http'
import coreApi from './coreApi'
import ies5Api from './ies5Api'
import sokplatformApi from './sokplatformApi'
import { jsFn } from '@/utils/jsFn'
import profile from '@/utils/profile'

var serverLocation = jsFn.isCN() ? 'cn' : 'global'
var blobUrl = profile.blobUrl[serverLocation]

export default {
    coreApi,
    ies5Api,
    sokplatformApi,
     /** 
     * NOTE: 取得網頁的HTML
     * @param {String} url - 指定的網頁
     * @return {String}
    */
    GetWebHTML: function(url) {
        return new Promise((resolve, reject) => {
            fetch('/os/GetWebHTML', {'url': url}).then(res => {
                resolve(res)
            }, err => {
                reject(err)
            })
        })
    },
    /** 
     * NOTE: 取得HiTA5 更新資訊
     * @return {String}
    */
    GetAPPVerInfo: function() {
        return new Promise((resolve, reject) => {
            fetch(blobUrl + '/public/HiTA/HiTA5Ver.json').then(res => {
                resolve(res)
            }, err => {
                reject(err)
            })
        })
    },
}
